
import { ComponentCreator, createComponentCreator, styleInject } from 'packages/css-component-modules';

const _css = `@-webkit-keyframes slide-up_395d45423eecd628{0%{top:112px}to{top:0}}@keyframes slide-up_395d45423eecd628{0%{top:112px}to{top:0}}@-webkit-keyframes slide-down_20c94899fc1bdb59{0%{top:0}to{top:112px}}@keyframes slide-down_20c94899fc1bdb59{0%{top:0}to{top:112px}}.ToastFrame_0b8bd097ac2c3e13{position:fixed;bottom:0;left:0;right:0;max-height:112px;z-index:15;display:flex;justify-content:center;padding:0 12px;background:transparent}.ToastContainer_079a77165bf63165{position:relative;width:100%;max-width:400px;min-height:48px;max-height:112px;padding:16px 16px 0;display:flex;flex-wrap:wrap;background:var(--backgroundColor_c751140294872027);border-top-right-radius:6px;border-top-left-radius:6px;box-shadow:0 0 16px rgba(0,0,0,.2);-webkit-animation:slide-up_395d45423eecd628 var(--animationDuration_f460d756a42bc6f3) ease-in-out forwards;animation:slide-up_395d45423eecd628 var(--animationDuration_f460d756a42bc6f3) ease-in-out forwards}.ToastContainer_079a77165bf63165.isHiding_fae29363b06b48fe{-webkit-animation:slide-down_20c94899fc1bdb59 var(--animationDuration_f460d756a42bc6f3) ease-in-out forwards;animation:slide-down_20c94899fc1bdb59 var(--animationDuration_f460d756a42bc6f3) ease-in-out forwards}.ToastContainer_079a77165bf63165 .Text_49d8b730bcd92222{display:inline-block;margin-top:0;margin-bottom:16px;line-height:16px;font-size:12px;font-weight:700}.VisuallyHidden_b77ef3a4642c3519{border:0;clip:rect(0 0 0 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px;white-space:nowrap;word-wrap:normal}.ToastContainer_079a77165bf63165 .Button_05aa018e5767e3b8{margin-left:auto;margin-top:-16px;height:48px;background:transparent;color:var(--buttonColor_c09a0aaf000d6a6d);border:none;cursor:pointer;font-weight:600;font-size:12px;text-transform:uppercase}`;
styleInject(_css)

/** ToastFrame Props */
export type ToastFrameCCM = {
  /** ToastFrame Component Custom Properties */
  // No custom properties found

  /** ToastFrame Modifier Flags */
  // No modifiers classes found
};
/** Base ToastFrame component */
export const ToastFrame: ComponentCreator<ToastFrameCCM> = createComponentCreator({
  "name": "ToastFrame",
  "base": "ToastFrame_0b8bd097ac2c3e13",
  "prop": {},
  "mod": {}
});


/** ToastContainer Props */
export type ToastContainerCCM = {
  /** ToastContainer Component Custom Properties */
  '$backgroundColor': string;
  '$animationDuration': string;

  /** ToastContainer Modifier Flags */
  '$isHiding'?: boolean;
};
/** Base ToastContainer component */
export const ToastContainer: ComponentCreator<ToastContainerCCM> = createComponentCreator({
  "name": "ToastContainer",
  "base": "ToastContainer_079a77165bf63165",
  "prop": {
    "$backgroundColor": "--backgroundColor_c751140294872027",
    "$animationDuration": "--animationDuration_f460d756a42bc6f3"
  },
  "mod": {
    "$isHiding": "isHiding_fae29363b06b48fe"
  }
});


/** Text Props */
export type TextCCM = {
  /** Text Component Custom Properties */
  // No custom properties found

  /** Text Modifier Flags */
  // No modifiers classes found
};
/** Base Text component */
export const Text: ComponentCreator<TextCCM> = createComponentCreator({
  "name": "Text",
  "base": "Text_49d8b730bcd92222",
  "prop": {},
  "mod": {}
});


/** VisuallyHidden Props */
export type VisuallyHiddenCCM = {
  /** VisuallyHidden Component Custom Properties */
  // No custom properties found

  /** VisuallyHidden Modifier Flags */
  // No modifiers classes found
};
/** Base VisuallyHidden component */
export const VisuallyHidden: ComponentCreator<VisuallyHiddenCCM> = createComponentCreator({
  "name": "VisuallyHidden",
  "base": "VisuallyHidden_b77ef3a4642c3519",
  "prop": {},
  "mod": {}
});


/** Button Props */
export type ButtonCCM = {
  /** Button Component Custom Properties */
  '$buttonColor': string;

  /** Button Modifier Flags */
  // No modifiers classes found
};
/** Base Button component */
export const Button: ComponentCreator<ButtonCCM> = createComponentCreator({
  "name": "Button",
  "base": "Button_05aa018e5767e3b8",
  "prop": {
    "$buttonColor": "--buttonColor_c09a0aaf000d6a6d"
  },
  "mod": {}
});

